<template>
  <b-modal ref="saveReportModal" title="Save Report" @ok="saveChanges" @cancel="reset" @close="reset" no-close-on-backdrop no-close-on-esc>
    <form v-on:submit.prevent.stop="saveChanges">
      <b-form-group label="Report Name">
        <b-form-input v-model="reportName" required></b-form-input>
      </b-form-group>
      <b-form-group label="Company">
        <b-form-select :disabled="companyId != null" v-model="company">
          <option :value="null">Admins Only</option>
          <option v-for="(company, companyIndex) in reportOptions.companies" :key="companyIndex" :value="company">{{company.name}}</option> 
        </b-form-select>
      </b-form-group>
      <b-form-group label="Team(s):" v-if="availableTeams != null && availableTeams.length > 0">
        <b-form-checkbox-group stacked v-model="teams" name="teams">
          <b-form-checkbox v-for="(team, teamIndex) in availableTeams" :key="teamIndex" :value="team">{{team.name}}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-alert show variant="info" v-if="company != null">The above options determine who has access to this report. The data a user can report on is determined by their own permissions</b-alert>
<!--       <b-form-group label="Lock Filters:" v-if="company != null && report.filters.length > 0">
        <b-form-checkbox-group>
          <b-form-checkbox v-for="(filter, filterIndex) in report.filters" :key="filterIndex" v-model="filter.locked">{{filterName(filter)}}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-alert show variant="info" v-if="company != null && report.filters.length > 0">Users cannot modify locked or remove filters. Admins can always modify or remove them, and you can save the report again to change which filters are locked for users.</b-alert> -->
    </form>
  </b-modal>
</template>

<script>
import API from '@/lib/api'

export default {
  name: 'SaveReportModal',
  props: ['admin', 'companyId', 'teamIds', 'reportId', 'report', 'reportOptions'],
  components: {},
  data () {
    const company = this.companyId != null ? this.reportOptions.companies.find((c) => { return parseInt(this.companyId) === c.id }) : null
    var teams = []
    if (this.teamIds != null && company != null) {
      teams = this.teamIds.map((id) => { return company.teams.find((team) => { return parseInt(id) === team.id }) })
    }
    return {
      reportName: this.report.name,
      company: company,
      teams: teams,
      isValid: true,
      errorMessage: ''
    }
  },
  computed: {
    availableTeams () {
      if (this.company != null) {
        return this.company.teams
      } else {
        return null
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    filterName (filter) {
      if (filter.type === 'data_entry') {
        if (filter.field_id != null) {
          const field = this.reportOptions.data_entry_fields.find((field) => { return field.id === parseInt(filter.field_id) })
          if (field != null) {
            return field.short_name
          }
        }
      }
      return this.reportOptions.filters.find((template) => { return template.type === filter.type }).name
    },
    show () {
      this.$refs.saveReportModal.show()
    },
    validate () {
      this.isValid = true
      return this.isValid
    },
    reset (evt) {
      this.company = this.companyId != null ? this.reportOptions.companies.find((c) => { return parseInt(this.companyId) === c.id }) : null
      this.teams = []
      if (this.teamIds != null && this.company != null) {
        this.teams = this.teamIds.map((id) => { return this.company.teams.find((team) => { return parseInt(id) === team.id }) })
      }
      this.reportName = this.report.name
      this.isValid = true
      this.errorMessage = ''
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    commit () {
      var params = {
        admin: this.admin,
        report: this.report,
        team_ids: this.teams.map((team) => { return team.id })
      }
      if (this.company != null) {
        params.company_id = this.company.id
        this.report.filters = this.report.filters.filter((f) => { return f.type !== 'company' })
      }
      this.report.name = this.reportName
      if (this.reportId) {
        API.put(`/reports/${this.reportId}`, params, this.$store.getters.authHeaders)
          .then((response) => {
            this.$emit('reportSaved', this.report)
          })
      } else {
        API.post('/reports', params, this.$store.getters.authHeaders)
          .then((response) => {
            this.$emit('reportSaved', this.report)
          })
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/SaveReportModal.vue